const features = [
  {
    id: 'feat-1',
    icon: 'ri-hd-line',
    title: '全高清画质',
    desc: '最高支持4K超高清播放，配合智能码率自适应技术，根据网络环境自动匹配最佳画质，保证清晰度的同时确保流畅不卡顿。',
  },
  {
    id: 'feat-2',
    icon: 'ri-speed-up-line',
    title: '智能加速不缓冲',
    desc: '自主研发的CDN加速网络覆盖全国主要节点，多线路智能切换，告别缓冲等待。即点即播，秒开体验，观影全程零等待。',
  },
  {
    id: 'feat-3',
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '7x24小时内容监控与更新系统，热播剧集上线后24小时内完成上架。院线新片下映后第一时间收录，让你抢先一步看新片。',
  },
  {
    id: 'feat-4',
    icon: 'ri-shield-check-line',
    title: '纯净无广告',
    desc: '坚持用户体验优先，播放全程无插播广告。通过技术优化降低运营成本，而非牺牲用户观影体验来获取广告收入。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50">平台优势</h2>
          <p className="text-foreground-500 text-sm mt-2">为什么千万用户选择桔子影院</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feat) => (
            <div
              key={feat.id}
              className="bg-background-50 rounded-xl p-6 border border-background-300/30 hover:border-primary-500/20 transition-all duration-300 group"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center mb-4 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${feat.icon} text-primary-400 text-xl`}></i>
              </div>
              <h3 className="text-foreground-100 font-bold text-sm mb-2">{feat.title}</h3>
              <p className="text-foreground-600 text-xs leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}